/*
 * Dynamically inserts SEO markup about each item on a PLP
 */
document.addEventListener("algolia.instantSearch.onRender", function () {
  const scriptId = "fp-algolia-plp__schema-markup";
  const hits = window.algoliaShopify.instantsearch.search.helper.lastResults?.hits || [];

  const schemaMarkup = document.getElementById(scriptId);

  if (schemaMarkup) {
    schemaMarkup.remove();
  }

  const itemListElements = hits.map((hit, i) => {
    return {
      "@type": "ListItem",
      position: `${i}`,
      item: {
        "@type": "Product",
        name: `${hit.title}`,
        url: `${window.location.origin}/products/${hit.handle}`,
        image: `${hit.image}`,
        sku: `${hit.sku}`,
        brand: {
          "@type": "Brand",
          name: `${hit.vendor}`,
        },
        offers: {
          "@type": "Offer",
          priceCurrency: "USD",
          price: `${hit.price}`,
          availability: "https://schema.org/InStock",
        },
      },
    };
  });

  if (itemListElements.length > 0) {
    const seoScript = document.createElement("script");
    seoScript.type = "application/ld+json";
    seoScript.id = scriptId;

    seoScript.innerHTML = `
      {
        "@context": "https://schema.org/",
        "@type": "ItemList",
        "url": "${window.location.origin}${window.location.pathname}",
        "itemListElement": ${JSON.stringify(itemListElements)}
      }
    `;

    document.body.append(seoScript);
  }
});
